import React, { useState, useEffect } from "react";
import { useQuery, useQueries } from 'react-query'
import { getResultsRSC, getResultsPhase, getUnits, getPhases, getCumulativeResult } from "data/Querys"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Loader from 'components/general/Loader'
import { useViewport } from 'components/general/useViewPort'
import PageHeader from "components/common/PageHeader";
import Label from "components/general/Label";
import NotAvailable from "components/common/NotAvailable";
import { isLiveStatus, isStartListStatus, isFinishedStatus } from "helpers/status";
import RecordsPrototype from "components/general/RecordsPrototype";
import ProgressionRule from "components/common/ProgressionRule";
import { getPhaseRSC, getLevelRSC, getLongPhaseRSC } from 'helpers/rsc'
import { isSpeedQualification, isSpeedSeeding } from "components/sports/clb/helper/ClbHelpers";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';


// Heats
import Heats from 'components/sports/clb/events/speed/HeatsQualification'
import LuckyLooser from "../events/speed/LuckyLooser";
// Summary
import Summary from "../events/speed/Summary";


const ClbSpeedQualification = () => {

    const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();

    //GET UNITS IN PHASE
    let filterScheduled = getLevelRSC(mirs_rsc) === 'PHASE' ? 'S' : 'Y'
    const { data: unitsData, isError: unitsError, isLoading: unitsLoading } = useQuery(
        {
            queryKey: ['unitsPhase', mirs_competition, mirs_language, getPhaseRSC(mirs_rsc), filterScheduled],
            queryFn: getUnits,
            //refetchInterval: 30000,
            staleTime: Infinity,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        }
    );


    //GET ALL RESULTS IN PHASE 
    const rscConfig = mirs_rsc;
    let queryArray = [];
    unitsData?.phase?.units?.forEach((unit) => {
        queryArray.push({
            queryKey: ['resultsData', mirs_competition, unit.code, mirs_language, rscConfig],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    });

    //SUMMARY (Poner dentro de array de datos quye se recuperan)
    const { data: phaseData, isError: phaseError, isLoading: phaseLoading } = useQuery(
        {
            queryKey: ['resultsPhaseSummary', mirs_competition, getPhaseRSC(mirs_rsc), mirs_language],
            queryFn: getResultsPhase,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        });

    const results = useQueries(queryArray);
    const isLoading = phaseLoading || unitsLoading || results.some(result => result.isLoading)
    const isError = phaseError || unitsError || results.some(result => result.isError)

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }

    const filtersQualRule = {
        type: ['QUALIFICATION'],
        code: ['QUAL_RULE']
    };

    let phaseResult = {}
    let phaseResultStatus
    let phaseResultStatusDescription
    if (phaseData && phaseData?.phaseResults && Array.isArray(phaseData.phaseResults) && phaseData.phaseResults.length > 0) {
        phaseResult = phaseData.phaseResults[0]
        phaseResultStatus = phaseResult?.status?.code
        phaseResultStatusDescription = phaseResult?.status?.description
    }
    let phaseResultArray = phaseResult && phaseResult?.items && Array.isArray(phaseResult.items) ? phaseResult.items : [];
    phaseResultArray?.sort((a, b) => a?.sortOrder - b?.sortOrder);

    const resultsElimitation = results?.filter(result => isSpeedQualification(result?.data?.results?.eventUnitCode))?.map(result => result?.data)
    const resultsSeeding = results?.filter(result => isSpeedSeeding(result?.data?.results?.eventUnitCode))?.map(result => result?.data)
    let data = []
    let extraData = []
    resultsElimitation?.forEach(result => {
        const heat = result?.results?.eventUnitCode?.slice(-1)
        const laneA = result?.results?.items?.find(item => item?.startSortOrder === 1)
        const laneB = result?.results?.items?.find(item => item?.startSortOrder === 2)
        const qualA = phaseResultArray?.find(item => item?.participant?.code === laneA?.participant?.code)?.qualificationMark
        const qualB = phaseResultArray?.find(item => item?.participant?.code === laneB?.participant?.code)?.qualificationMark
        const qA = qualA ? { qualificationMark: qualA } : {}
        const qB = qualB ? { qualificationMark: qualB } : {}
        let rerun = {};
        const rerunValue = result?.results?.extendedInfos?.find(ei => ei?.ei_code === 'RERUN')?.ei_value;
        if (rerunValue) {
            rerun = { rerun: rerunValue }
        }
        if (!isNaN(heat) && heat !== '0') {
            data.push({
                heatSortOrder: 10 * Number(heat) + 1,
                heat: heat,
                lane: 'A',
                scheduleStatus: result?.results?.schedule?.status?.code,
                resultStatus: result?.results?.status?.code,
                ...rerun,
                ...qA,
                ...laneA
            });
            data.push({
                heatSortOrder: 10 * Number(heat) + 2,
                heat: heat,
                lane: 'B',
                scheduleStatus: result?.results?.schedule?.status?.code,
                resultStatus: result?.results?.status?.code,
                ...rerun,
                ...qB,
                ...laneB
            });
            extraData.push({
                heat: heat,
                scheduleStatus: result?.results?.schedule?.status?.code,
                resultStatus: result?.results?.status?.code
            })
        }
    })

    if (!resultsElimitation || !Array.isArray(resultsElimitation) || resultsElimitation.length === 0) return <NotAvailable />

    let luckyLoserData = []
    if (phaseResultArray.find(phr => phr?.qualificationMark === 'q')) {
        luckyLoserData = [phaseResultArray?.find(phr => phr?.qualificationMark === 'q')];

    } else if (phaseResultArray.find(phr => phr?.qualificationMark !== 'Q')) {
        luckyLoserData = [phaseResultArray?.find(phr => phr?.qualificationMark !== 'Q')];

    } else {
        let resultsSeedingItems = resultsSeeding && Array.isArray(resultsSeeding) && resultsSeeding.length > 0 && resultsSeeding[0]?.results?.items ? resultsSeeding[0]?.results?.items : []
        let firstLuckyLoserData = resultsSeedingItems && Array.isArray(resultsSeedingItems) ? resultsSeedingItems.find(i => i?.sortOrder === 1) : undefined;
        luckyLoserData = firstLuckyLoserData ? [firstLuckyLoserData] : luckyLoserData;
    }

    return (<>
        <PageHeader data={resultsElimitation[0]} />

        {resultsElimitation[0]?.records &&

            <RecordsPrototype records={resultsElimitation[0]?.records} forceResultTypeHader={'HeaderPoints'} forceMobileColumns={['Date', 'Location']} />

        }

        <ProgressionRule key="progress-component" data={resultsElimitation[0]?.config} filter={filtersQualRule} itemData={'value'} />

        <Tabs id="mirs-navsport" defaultActiveKey={`1-${mirs_rsc}`} className="mb-3 mirs-tab-result">

            <Tab eventKey={`1-${mirs_rsc}`} title={(<Label data='Heats' />)} >
                <Heats data={data} extraData={extraData} mirs_competition={mirs_competition} mirs_language={mirs_language} mirs_rsc={mirs_rsc} breakPoint={breakPoint} />
                <LuckyLooser data={luckyLoserData} />
            </Tab>

            <Tab eventKey={`2-${mirs_rsc}`} title={(<Label data='Summary' />)} disabled={!isFinishedStatus(phaseResultStatus)} >
                <Summary data={phaseResultArray} extraData={phaseResultStatusDescription} breakPoint={breakPoint} />
            </Tab>

        </Tabs>
    </>)
}

export default ClbSpeedQualification;